const TaskIndicatorCard = ({
  title = "",
  value,
  color = "#C9F8D1",
  onClick = null,
  margin = 0,
  text,
  centerContent = null,
  height = "auto"  
}) => {
  return (
    <div
      onClick={onClick || undefined}
      style={{
        background: color,
        padding: "14px 24px",
        borderRadius: "12px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        cursor: onClick ? "pointer" : "default",
        minWidth: "120px",
        textAlign: "center",
        transition: "0.2s ease",
        margin,
        height  
      }}
    >
       {title && (
        <span
          style={{
            color: "#2F3A80",
            fontWeight: "600",
            fontSize: "14px"
          }}
        >
          {title}
        </span>
      )}

       {text && (
        <span
          style={{
            fontSize: "15px",
            fontWeight: "600",
            color: "#000"
          }}
        >
          {text}
        </span>
      )}

       {centerContent && (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "6px 0",
            flexGrow: 1  
          }}
        >
          {centerContent}
        </div>
      )}

       {value !== undefined && value !== null && (
        <span
          style={{
            marginTop: "4px",
            fontSize: "22px",
            fontWeight: "700",
            color: "#000"
          }}
        >
          {value}
        </span>
      )}
    </div>
  );
};

export default TaskIndicatorCard;
